export const generateEventData = (datas: any, device: any, os: any, address: any) => {
  return {
    event: datas.event,
    device: os,
    device_type: device,
    event_action: datas.event_action,
    event_category: datas.event_category,
    event_label: datas.event_label,
    event_ga: datas.event_ga,
    version: datas.version,
    product: datas.product,
    location: address?.city,
  };
};